import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { RiMenuSearchFill } from '@remixicon/react';
import { taskExplorerRootRouteRef } from '../../routes';

// Note: also mounted as a scaffolder sub-page in the app override
export { TaskExplorerPage } from './task-explorer-page';

export const taskExplorerPage = PageBlueprint.make({
  name: 'task-explorer-page',
  params: {
    title: 'Task Explorer',
    icon: <RiMenuSearchFill />,
    path: '/task-explorer',
    routeRef: taskExplorerRootRouteRef,
    loader: () =>
      import('./task-explorer-page').then(m => <m.TaskExplorerPage />),
  },
});
